import { AppRouteProps } from "@bsm/component";
import { ScholarityDetailsContainer } from "./container/ScholarityDetailsContainer";
import { ScholarityCreateContainer } from "../create/container/ScholarityCreateContainer";


export const ScholarityDetailsRoute = [
    {
        path: ":scholarityId",
        element: <ScholarityDetailsContainer />
    },
    {
        path: ":scholarityId/edit",
        element: <ScholarityCreateContainer />
    },
] as Array<AppRouteProps>